<div class="custom-navbar" [class.accessibility]="accessibility === true">
  <nav
    disableRipple
    mat-tab-nav-bar
    class="fxhp-custom-tabs top-nav-links"
    [tabPanel]="tabPanel"
  >
    <mat-tab-nav-panel #tabPanel class="tab-panel">
      <a
        *ngFor="let link of links"
        mat-tab-link
        queryParamsHandling="preserve"
        [routerLink]="link.route"
        [attr.data-cy]="link.route"
        [active]="activeLink === link.route"
        [class.mdc-tab-indicator--active]="activeLink === link.route"
        (click)="activeLink = link.route"
      >
        {{ link.label }}
      </a>
    </mat-tab-nav-panel>
  </nav>
</div>
